const GENERAL_TAB = '[data-tour="setting-general"]';
const SYSTEM_CONFIG_TAB = '[data-tour="setting-system-configuration"]';
const TIME_REGION = '[data-tour="setting-time-region"]';
const NOTIFICATION = '[data-tour="setting-notification"]';
const INVITATION = '[data-tour="setting-invitation"]';
const ATTENDANCE_LEAVE_TAB = '[data-tour="setting-attendance-leave"]';
const ATTENDANCE = '[data-tour="setting-attendance"]';
const LEAVE = '[data-tour="setting-leave"]';
const LOCATION = '[data-tour="setting-location"]';
const ORGANIZATION_TAB = '[data-tour="setting-organization"]';
const DEPARTMENT = '[data-tour="setting-department"]';
const DESIGNATION = '[data-tour="setting-designation"]';
const CLIENT_TAB = '[data-tour="setting-client"]';
const CLIENT_LEAVE = '[data-tour="setting-client-leave"]';
const CLIENT_NOTIFICATION = '[data-tour="setting-client-notification"]';

/** Chờ window handler sau khi tab mount */
const waitForWindowFn = (name, timeout = 2000) =>
  new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = () => {
      if (typeof window[name] === "function") {
        resolve(window[name]);
        return;
      }
      if (Date.now() - start >= timeout) {
        reject(new Error(`${name} not ready`));
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });

const goToGeneralMain = () => {
  window.__setSettingsMainTab?.(0);
};

const goToClientMain = () => {
  window.__setSettingsMainTab?.(1);
};

/** General + sub-tab System Configuration (index 0) */
const goToSystemConfig = async () => {
  goToGeneralMain();
  try {
    const setGeneral = await waitForWindowFn("__setSettingsGeneralTab");
    setGeneral(0);
  } catch (e) {
    console.warn(e);
  }
};

/** General + Attendance & Leave (index 1) */
const goToAttendanceLeave = async () => {
  goToGeneralMain();
  try {
    const setGeneral = await waitForWindowFn("__setSettingsGeneralTab");
    setGeneral(1);
  } catch (e) {
    console.warn(e);
  }
};

/** General + Organization (index 2) */
const goToOrganization = async () => {
  goToGeneralMain();
  try {
    const setGeneral = await waitForWindowFn("__setSettingsGeneralTab");
    setGeneral(2);
  } catch (e) {
    console.warn(e);
  }
};

// Trả về steps theo hàm để hỗ trợ i18n
export const getSettingTourSteps = (t) => [
  {
    selector: '[data-tour="drawer-settings"]',
    content: t("tour.setting.drawer"),
  },
  {
    selector: GENERAL_TAB,
    content: t("tour.setting.general"),
    tourOpen: goToGeneralMain,
    tourWaitFor: GENERAL_TAB,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: SYSTEM_CONFIG_TAB,
    content: t("tour.setting.system-configuration"),
    tourOpen: goToSystemConfig,
    tourWaitFor: SYSTEM_CONFIG_TAB,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: TIME_REGION,
    content: t("tour.setting.time-region"),
    tourOpen: goToSystemConfig,
    tourWaitFor: TIME_REGION,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    tourScrollBlock: "start",
    mutationObservables: [TIME_REGION],
    resizeObservables: [TIME_REGION],
  },
  {
    selector: NOTIFICATION,
    content: t("tour.setting.notification"),
    tourOpen: goToSystemConfig,
    tourWaitFor: NOTIFICATION,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [NOTIFICATION],
    resizeObservables: [NOTIFICATION],
  },
  {
    selector: INVITATION,
    content: t("tour.setting.invitation"),
    tourOpen: goToSystemConfig,
    tourWaitFor: INVITATION,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [INVITATION],
    resizeObservables: [INVITATION],
  },
  {
    selector: ATTENDANCE_LEAVE_TAB,
    content: t("tour.setting.attendance-leave"),
    tourOpen: goToAttendanceLeave,
    tourWaitFor: ATTENDANCE_LEAVE_TAB,
    tourWaitFrames: 1,
    // Tab nằm trên đầu — scroll start để không bị cắt khi đang ở cuối System Config
    tourScrollBlock: "start",
  },
  {
    selector: ATTENDANCE,
    content: t("tour.setting.attendance"),
    tourOpen: goToAttendanceLeave,
    tourWaitFor: ATTENDANCE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    tourScrollBlock: "start",
    mutationObservables: [ATTENDANCE],
    resizeObservables: [ATTENDANCE],
  },
  {
    selector: LEAVE,
    content: t("tour.setting.leave"),
    tourOpen: goToAttendanceLeave,
    tourWaitFor: LEAVE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [LEAVE],
    resizeObservables: [LEAVE],
  },
  {
    selector: LOCATION,
    content: t("tour.setting.location"),
    tourOpen: goToAttendanceLeave,
    tourWaitFor: LOCATION,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [LOCATION],
    resizeObservables: [LOCATION],
  },
  {
    selector: ORGANIZATION_TAB,
    content: t("tour.setting.organization"),
    tourOpen: goToOrganization,
    tourWaitFor: ORGANIZATION_TAB,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: DEPARTMENT,
    content: t("tour.setting.department"),
    tourOpen: goToOrganization,
    tourWaitFor: DEPARTMENT,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    tourScrollBlock: "start",
    mutationObservables: [DEPARTMENT],
    resizeObservables: [DEPARTMENT],
  },
  {
    selector: DESIGNATION,
    content: t("tour.setting.designation"),
    tourOpen: goToOrganization,
    tourWaitFor: DESIGNATION,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [DESIGNATION],
    resizeObservables: [DESIGNATION],
  },
  {
    selector: CLIENT_TAB,
    content: t("tour.setting.client"),
    tourOpen: goToClientMain,
    tourWaitFor: CLIENT_TAB,
    tourWaitFrames: 1,
    tourScrollBlock: "start",
  },
  {
    selector: CLIENT_LEAVE,
    content: t("tour.setting.client-leave"),
    tourOpen: goToClientMain,
    tourWaitFor: CLIENT_LEAVE,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    tourScrollBlock: "start",
    mutationObservables: [CLIENT_LEAVE],
    resizeObservables: [CLIENT_LEAVE],
  },
  {
    selector: CLIENT_NOTIFICATION,
    content: t("tour.setting.client-notification"),
    tourOpen: goToClientMain,
    tourWaitFor: CLIENT_NOTIFICATION,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [CLIENT_NOTIFICATION],
    resizeObservables: [CLIENT_NOTIFICATION],
  },
];
